module.exports = __webpack_public_path__ + "img/orange-student.64bf16fa.png";